import { Container, Row, Col } from 'reactstrap'

export default function DownloadAppSection() {
  return (
    <section className="features-section features-cta bg-white">
      <Container>
        <Row className="align-items-top">
          <Col md="6" className="phones-mockup d-none d-md-block">
            <div className="phone phone-right">
              <img src="/images/lp/mockup-iphone.png" alt="App mockup" />
            </div>
          </Col>
          <Col md="6" className="download-content-mobile">

            {/* Desktop content */}
            <div className="d-none d-md-block">
              <h2 className="section-title text-primary mb-5">
                Seu próximo adversário está a um clique
              </h2>
              <p className="section-subtitle mb-4">
                Conheça novos jogadores, vendo seu histórico de partidas, como eles jogam, qual o aproveitamento por tipo de superfície e quais Conquistas já alcançaram.
              </p>
            </div>


            {/* Mobile content */}
            <div className="d-md-none">
              <h2 className="section-title text-primary mb-2">
                Seu próximo adversário está a um clique
              </h2>
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column mt-4"
                  style={{ width: '50%' }}>
                  <p>
                    Conheça novos jogadores, vendo seu histórico de partidas, como eles jogam, qual o aproveitamento por tipo de superfície e quais Conquistas já alcançaram.
                  </p>
                </div>
                <div>
                  <img src="/images/lp/mockup-iphone.png" alt="App mockup"
                    style={{ width: '180px', height: 'auto' }} />
                </div>
              </div>
            </div>

            <div
              className="download-buttons-dark download-buttons-dark-mobile"
              style={{ width: '100%', display: 'flex' }}
            >
              <a
                href="#"
                className="download-btn-dark download-btn-ios"
                onClick={e => {
                  e.preventDefault()
                  window.open(
                    'https://apps.apple.com/us/app/clube-do-tennis/id6747998672',
                    '_blank',
                  )
                }}
                style={{
                  backgroundColor: '#1D1D1D',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                }}
                aria-label="Baixar na App Store"
              >
                <span className="store-icon-dark" aria-hidden>
                  <img src="/images/lp/apple-logo.png" alt="App Store" />
                </span>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="store-small-dark text-white">
                    Disponível na
                  </span>
                  <span
                    className="store-name-dark text-white"
                    style={{ fontWeight: '600' }}
                  >
                    App Store
                  </span>
                </div>
              </a>
              <a
                href="#"
                className="download-btn-dark download-btn-android"
                onClick={e => {
                  e.preventDefault()
                  window.open(
                    'https://play.google.com/store/apps/details?id=br.com.clubedotennis.app',
                    '_blank',
                  )
                }}
                aria-label="Baixar no Google Play"
                style={{
                  backgroundColor: '#1D1D1D',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                }}
              >
                <span className="store-icon-dark" aria-hidden>
                  <img src="/images/lp/google-play.png" alt="Google Play" />
                </span>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px',
                  }}
                >
                  <span className="store-small-dark text-white">
                    Disponível na
                  </span>
                  <span
                    className="store-name-dark text-white font-weight-bold"
                    style={{ fontWeight: '600' }}
                  >
                    Google Play
                  </span>
                </div>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
